import type { MyAppsRegistryEntry } from './myAppsTypes';

export const PORTAL_MY_APPS_PATHS = {
  documentEditor: '/apps/document-editor',
  spreadsheetEditor: '/apps/spreadsheet-editor',
  pdfViewer: '/apps/pdf-viewer',
  drawioEditor: '/apps/drawio-editor'
} as const;

/**
 * Presentation for the apps in <c>SharedMyAppsCatalog</c>. Ids must match the server.
 */
export const PORTAL_MY_APPS_REGISTRY: readonly MyAppsRegistryEntry[] = [
  {
    id: 'document-editor',
    path: PORTAL_MY_APPS_PATHS.documentEditor,
    icon: 'dx-icon-docxfile',
    keywords: ['word', 'document', 'docx', 'office', 'richedit', 'letter']
  },
  {
    id: 'spreadsheet-editor',
    path: PORTAL_MY_APPS_PATHS.spreadsheetEditor,
    icon: 'dx-icon-xlsxfile',
    keywords: ['excel', 'spreadsheet', 'xlsx', 'office', 'workbook']
  },
  {
    id: 'pdf-viewer',
    path: PORTAL_MY_APPS_PATHS.pdfViewer,
    icon: 'dx-icon-pdffile',
    keywords: ['pdf', 'viewer', 'read', 'annotate', 'acrobat', 'document']
  }
];

/** WebOps-only presentation for Draw.io. Ids must match <c>WebOpsMyAppsCatalog</c>. */
export const WEBOPS_DRAWIO_REGISTRY_ENTRY: MyAppsRegistryEntry = {
  id: 'drawio-editor',
  path: PORTAL_MY_APPS_PATHS.drawioEditor,
  icon: 'dx-icon-hierarchy',
  keywords: ['drawio', 'draw.io', 'diagram', 'flowchart', 'uml', 'architecture']
};

export const WEBOPS_MY_APPS_REGISTRY: readonly MyAppsRegistryEntry[] = [
  ...PORTAL_MY_APPS_REGISTRY,
  WEBOPS_DRAWIO_REGISTRY_ENTRY
];
